<script>
import resources from './resources'

export default {
  name: 'professional-schedules-preview',

  mixins: [resources]
}
</script>

<template lang="pug">
  div
    .row
      div.col-xs-12.col-sm-10.col-sm-offset-1
        h4 AGENDAMENTOS
          span(v-html="title")
        table.table.table-fixed.table-hover
          thead
            tr
              th.col-xs-2 #
              th.col-xs-2 Data
              th.col-xs-2 Hora
              th.col-xs-2 Dia da semana
          tbody
            tr(v-for="(schedule, index) in schedules", :key="schedule.id")
              td.col-xs-1
                input(type="checkbox", v-model="schedule.lock")
              td.col-xs-1 {{ schedule.date }}
              td.col-xs-1 {{ schedule.time }}
              td.col-xs-1 {{ schedule.day }}
        .buttons-wrapper
          //- v-if="isValid"
          button.btn.save(@click.prevent="doLocks()")
            | Bloquear



// WEBPACK FOOTER //
// src/app/professional/agenda/rules/components/preview/preview.vue